
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { toast } from "sonner";

interface ConsentCallbackHandlerProps {
  isProcessing: boolean;
  onConsentCode: (code: string) => Promise<boolean>;
}

export function ConsentCallbackHandler({ isProcessing, onConsentCode }: ConsentCallbackHandlerProps) {
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get('code');
    const error = query.get('error');
    
    if (code) {
      const handleConsent = async () => {
        const success = await onConsentCode(code);
        if (success) {
          // Clean up URL after successful processing
          window.history.replaceState({}, document.title, "/mailboxes");
        }
      };
      
      handleConsent();
    } else if (error) {
      toast.error("Failed to connect mailbox: " + (query.get('error_description') || error));
      sessionStorage.removeItem("pendingMailboxEmail");
      window.history.replaceState({}, document.title, "/mailboxes");
    }
  }, [location, onConsentCode]);

  if (isProcessing) {
    return (
      <Alert>
        <AlertDescription>
          Processing your mailbox connection. Please wait...
        </AlertDescription>
      </Alert>
    );
  }

  return null;
}
